/* eslint-disable prettier/prettier */
import mjml2html from 'mjml-browser'
import { EMAIL_CONTENT } from '../../theme/tokens'
import { BLOCK_TYPES } from './blocks'

/** Serialize a bhanzu-v1 design document to an MJML string. */
export const designToMjml = (design) => {
    const body = design.body ?? {}
    const sections = []
    let current = []

    const flush = () => {
        if (current.length) {
            sections.push(
                `<mj-section background-color="${
                    body.contentBackground ?? EMAIL_CONTENT.canvas
                }" padding="0"><mj-column>${current.join(
                    ''
                )}</mj-column></mj-section>`
            )
            current = []
        }
    }

    for (const block of design.blocks ?? []) {
        const def = BLOCK_TYPES[block.type]
        if (!def) continue
        if (def.toColumns) {
            // Multi-column blocks form their own section.
            flush()
            const cols = def
                .toColumns(block.props)
                .map((c) => `<mj-column>${c}</mj-column>`)
                .join('')
            sections.push(
                `<mj-section background-color="${
                    body.contentBackground ?? EMAIL_CONTENT.canvas
                }" padding="0 10px">${cols}</mj-section>`
            )
        } else {
            current.push(def.toMjml(block.props))
        }
    }
    flush()

    return [
        '<mjml>',
        '<mj-head>',
        '<mj-attributes>',
        `<mj-all font-family="Poppins, -apple-system, Segoe UI, Helvetica, Arial, sans-serif" />`,
        '</mj-attributes>',
        '</mj-head>',
        `<mj-body background-color="${
            body.backgroundColor ?? EMAIL_CONTENT.backdrop
        }" width="${body.contentWidth ?? 600}px">`,
        sections.join(''),
        '</mj-body>',
        '</mjml>',
    ].join('')
}

/**
 * Compile a design document to email-safe HTML.
 * Async — mjml-browser v5 returns a Promise. Resolves { html, errors };
 * errors is an array of MJML validation messages.
 */
export const compileDesign = async (design) => {
    try {
        const { html, errors } = await mjml2html(designToMjml(design), {
            validationLevel: 'soft',
        })
        return { html: html ?? '', errors: errors ?? [] }
    } catch (err) {
        return { html: '', errors: [{ message: err.message }] }
    }
}
